export const capitalizeGender = (gender: string | undefined | null): string => {
  if (!gender) return 'N/A';
  
  // Handle common gender values
  const genderMap: Record<string, string> = {
    'male': 'Male',
    'female': 'Female',
    'other': 'Other',
    'prefer-not-to-say': 'Prefer not to say',
    'Male': 'Male',
    'Female': 'Female',
    'Other': 'Other',
    'Prefer not to say': 'Prefer not to say'
  };
  
  return genderMap[gender.toLowerCase()] || gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase();
};
